// Platform AI keys (auth-service /platform/ai-settings via the gateway).
// The shared keys that serve tenants granted `dana_managed_key`. Reads are
// masked; the plaintext never returns to any browser.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);
const B = `${API_V1}/platform/ai-settings`;

export interface PlatformAiSettings {
  anthropicKeySet: boolean;
  anthropicKeyLast4: string | null;
  openaiKeySet: boolean;
  openaiKeyLast4: string | null;
  // The platform's default reasoning provider — which shared key managed tenants
  // use for Dana chat when they haven't chosen their own.
  defaultProvider: 'anthropic' | 'openai';
  defaultModel: string | null;
  updatedAt: string | null;
}

export const getPlatformAiSettings = () =>
  axios.get<PlatformAiSettings>(B).then((r) => r.data);

export const updatePlatformAiSettings = (body: {
  anthropicKey?: string | null;
  openaiKey?: string | null;
  defaultProvider?: 'anthropic' | 'openai' | null;
  defaultModel?: string | null;
}) => axios.put<PlatformAiSettings>(B, body).then((r) => r.data);
